import React, { useState } from 'react'
import HeadMeta from '../components/HeadMeta'

const kasugauraPage = () => {
  return (
<div>
  <HeadMeta title="BETSUDAI×TOS PRESENTS 春日浦DIYコラボ商品" description="DIYがきっと好きになるコラボ商品が誕生しました" />
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous"/>
  <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&family=Noto+Serif+JP:wght@300;400;500;600&display=swap" rel="stylesheet" />
  <link rel="stylesheet" href="/css/kasugaura.css" />
  <script src="https://code.jquery.com/jquery-3.6.1.min.js" integrity="sha256-o88AwQnZB+VDvE9tvIXrMQaPlFFSUTR+nldQm1LuPXQ=" crossOrigin="anonymous"></script>
  <script src="/js/kasugaura.js"></script>
  <div className="header">
    <div className="headerLogo">
      <a href="/" className="headerLogo_link">
        <img src="../../img/logo.png" alt="株式会社ベツダイ" />
      </a>
    </div>
    <input type="checkbox" name="menuTrigger" id="nav-input" className="nav-unshown" />
    <label id="nav-open" htmlFor="nav-input"><span></span></label>
    <label className="nav-unshown" id="nav-close" htmlFor="nav-input"></label>
    <nav className="header-nav">
      <ul className="header-navlist">
        <li className="header-navlist_item">
          <a href="#collabo" className="header-navlist_link">
            <img src="../../img/kasugaura/menu06.svg" alt="" />
          </a>
        </li>
        <li className="header-navlist_item">
          <a href="#story" className="header-navlist_link">
            <img src="../../img/kasugaura/menu01.svg" alt="" />
          </a>
        </li>
        <li className="header-navlist_item">
          <a href="#project" className="header-navlist_link">
            <img src="../../img/kasugaura/menu02.svg" alt="" />
          </a>
        </li>
        <li className="header-navlist_item">
          <a href="#goods" className="header-navlist_link">
            <img src="../../img/kasugaura/menu03.svg" alt="" />
          </a>
        </li>
        <li className="header-navlist_item">
          <a href="#member" className="header-navlist_link">
            <img src="../../img/kasugaura/menu04.svg" alt="" />
          </a>
        </li>
      </ul>
    </nav>
  </div>
  <div className="c-page-sub__main">
    <main id="collabo" >
      <div>
        <div className="contentSection heroSection">
          <img src="../../img/kasugaura/hero.png" alt="春日浦DIYコラボ商品" />
          <div className="image01">
            <img src="../../img/kasugaura/image01.png" alt="Products Lineup" />
          </div>
          <div className="boxRow">
            <div className="boxRow_item">
              <div className="lineupWrapper">

                <div className="boxRow_title">
                  Products Lineup
                </div>
                <div className="boxRow_lineup">
                  <div className="boxRow_lineupItem">
                    ワークエプロン
                    <div className="price">
                      ¥9,800<span>(税込)</span>
                    </div>
                  </div>
                  <div className="boxRow_lineupItem">
                    アイアンシェルフ
                    <div className="price">
                      ¥6,590<span>(税込)</span>
                    </div>
                  </div>
                  <div className="boxRow_lineupItem">
                    とりあえずパーテーション
                    <div className="price">
                      ¥11,000<span>(税込)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="boxRow_image">
              <img src="../../img/kasugaura/image02.png" alt="Products Lineup" />
            </div>
          </div>
          <img id="story" src="../../img/kasugaura/image09.png" alt="story" className="contentSection_title" />
          <div className="story">
            <div className="story_title">
              DIYがきっと好きになる<br />
              コラボ商品が誕生しました
            </div>
            <div className="story_text">
              TOSテレビ大分「ゆ〜わくワイド」×「ベツダイ」の<br />
              コラボ企画「春日浦DIY」プロジェクト。<br />
              第1弾の「春日浦リフォーム」に続く、<br />
              第2弾プロジェクトとして、<br />
              県内在住のDIYクリエイターや国内の企業と一緒に、<br />
              オリジナル商品を制作しました。<br />
              “DIYをもっと楽しく、身近に感じてもらいたい”。<br />
              皆の想いをぎゅっと詰め込んだ<br />
              3つのアイテムがようやく完成しました。
            </div>
          </div>
        </div>
        <img src="../../img/kasugaura/image03.png" alt="story" className="contentSection_footer" />
        <div className="contentSection talkSection" id="project">
          <div className="talk">

            <img src="../../img/kasugaura/image04.png" alt="story" className="talk_header" />
            <div className="talk_info">
              企画に携わった4人によるプロジェクトトークをお届けします。<br />
              これまでを振り返りながら、今だから話せるウラ話（？）も飛び出しました。

            </div>
            <div className="talk_title">
              <span>
                「DIYを気軽に感じてもらうには？」<br />
                プロダクトプロジェクトがスタート。
              </span>
            </div>
            <div className="talkList">
              <div className="talkList_item">
                <div className="name">
                  姫野
                </div>
                <div className="text">
                  TOSテレビ大分の番組「ゆ〜わくワイド」とのコラボ企画としてスタートした「春日浦DIYプロジェクト」。第1弾「春日浦リフォーム」では、県内外のDIYクリエイターと一緒に賃貸物件をリノベーションしました。物件は無事に完成しましたが、「もっと多くの人にDIYを身近に感じてもらいたい」と感じるようになりました。そこで、第2弾プロジェクトとして、実際にDIYを体験できる商品を開発することに。そこから協力してくれる企業探しがスタートしました。
                </div>
              </div>
              <div className="talkList_item">
                <div className="name">
                reks
                </div>
                <div className="text">
                DIYはSDGsを考えるきっかけになります。今回のプロジェクトを通して、多くの人に資源を再利用する大切さや廃棄物の削減について考えてもらうためには、皆さんに身近なアイテムを展開している企業とタッグを組むことが良いのではないかと考えました。熱意を持って提案し、無事に4社の企業に協力してもらうことになりました。

                </div>
              </div>
              <div className="talkList_item">
                <div className="name">
                aco
                </div>
                <div className="text">
                どのメーカーも、メディアや企業とタッグを組むのが初めてだったようです。4社とも私たちの想いに共感し、協力してくれました。積極的に意見を出し合い試行錯誤し進めていく刺激的な日々でした。大変なことも多かったけれど、とにかく楽しかった想い出ばかりです。大阪、東京に県外進出もできて、ここでは話せないエピソードもたくさんあります（笑）。

                </div>
              </div>
              <div className="talkList_item">
                <div className="name">
                HACHICO.
                </div>
                <div className="text">
                アイデアはたくさん出たけれど、実現可能なラインまでもっていくのが大変でした。オリジナルパーツをつくるのか、既存の商品を使うのか…など、企業の希望と細かく調整しながらつくりあげたので、出来上がったときの嬉しさや愛着はひとしおでした。
                </div>
              </div>
            </div>
            <div className="link" id="more">
              <span className="link_button">
                続きを読む
                <img src="../../img/kasugaura/icon_arrowBottom01.png" alt="" />
              </span>
            </div>
            <div className="talkListMore">
              <img src="../../img/kasugaura/image11.png" alt="" />
              <div className="talk_title">
                <span>
                何度も会議を重ね、試行錯誤し、<br />
                “私たちらしい”商品を考案。
                </span>
              </div>
              <div className="talkList">
                <div className="talkList_item">
                  <div className="name">
                    姫野
                  </div>
                  <div className="text">
                    どんな商品をつくるのか、チームで何度も話し合いました。「エプロンを作りたい！」という声は多かったので、エプロンの制作はすぐ決まりました。もともとは胸当てのあるタイプを検討していたのですが、胸当てがついていると着るのが面倒なようで、意外とエプロンをつけずに料理する人が多かったんです。そのため、腰巻きタイプのギャルソンエプロンに修正しました。ワークウェアのカッコよさも残しつつ、余計なものを削ぎ落としたシンプルでかわいい商品が出来上がったと思います。
                  </div>
                </div>
                <div className="talkList_item">
                  <div className="name">
                  reks
                  </div>
                  <div className="text">
                  コンセプトは、エプロンをつけたままお出かけしたくなるオシャレなエプロン。スマホを入れられる着脱可能な大きなポケット、お尻がすっぽり隠れる幅などシンプルな中にも機能性やこだわりをいっぱい詰め込みました。


                  </div>
                </div>
                <div className="talkList_item">
                  <div className="name">
                  aco
                  </div>
                  <div className="text">
                  卓上シェルフは、完成までかなり時間がかかりました。当初スツールを作る予定だったのですが、途中で白紙になり急遽商品を変更することに。実は商品が番組の撮影当日まで決まらなくて（笑）、現場で話し合いを重ねた結果、アイアンのオリジナルパーツを作ってもらってこのシェルフが生まれました。


                  </div>
                </div>
                <div className="talkList_item">
                  <div className="name">
                  reks
                  </div>
                  <div className="text">
                  卓上シェルフとして打ち出しているけれど、天井から吊り下げる棚として使ってもいいし、逆にしてブックスタンドとしても使えますので、使う場所や用途によって自由にアレンジできます。一見男前系アイテムですが、さまざまなテイストの雰囲気にもマッチする商品だと思います。

                  </div>
                </div>
                <div className="talkList_item">
                  <div className="name">
                  姫野
                  </div>
                  <div className="text">
                  パレットは、リモートワークの場所で悩む人に向けたデスクを作るため、SATOCOMPANYの製品を使いたいと思ったのがはじまり。「デスクだけでなく、パーテーションとしても活用できるんじゃないか」、「平安伸銅工業の突っ張り棒を組み合わせたら収納アイテムとしても使えるようになるんじゃないか」。制作過程で溢れるアイデアをひとつひとつ組み合わせながらカタチにしていきました。


                  </div>
                </div>
                <div className="talkList_item">
                  <div className="name">
                  reks
                  </div>
                  <div className="text">
                  自分たちの意見をベースに一から商品開発するなんてなかなか体験できることではありません。その分、こだわりや愛情が詰まっているし、本当に便利だと思うものが完成しました。たくさんの人に使っていただきたいという気持ちでいっぱいです。
                  </div>
                </div>
              </div>
              <img src="../../img/kasugaura/image12.png" alt="" />
              <div className="talk_title">
                <span>
                空き家をまるごと改造する<br />
                大分県との一大プロジェクト！？

                </span>
              </div>
              <div className="talkList">
                <div className="talkList_item">
                  <div className="name">
                  reks
                  </div>
                  <div className="text">
                  一体感のあるチームで、メンバーが１人でも欠けたら、プロジェクトは成功しなかったかもしれません。思いっきりふざけるし楽しむけれど、やるときはやるメンバーばかり。それぞれの個性が光る商品が出来上がりました。

                  </div>
                </div>
                <div className="talkList_item">
                  <div className="name">
                  aco
                  </div>
                  <div className="text">
                  reksさんは男前系、HACHICO.さんは韓国インテリア系、わたしはナチュラル系…と、みんなジャンルやテイストも違いますが、「DIYが好き」という想いは同じ。どんどんアイデアが湧き出て、最終的にキレイにまとまりました。また4人で何か作りたいですね。



                  </div>
                </div>
                <div className="talkList_item">
                  <div className="name">
                  HACHICO.
                  </div>
                  <div className="text">
                  それぞれ本当に個性的だけれど、プラス思考で前向きなメンバーだったからこそ、やり遂げられました。これからもこのメンバーで何かをやりたいんですが、今後のビジョンやプロジェクトはあるんですか？



                  </div>
                </div>
                <div className="talkList_item">
                  <div className="name">
                  姫野
                  </div>
                  <div className="text">
                  実は…、空き家丸ごとリノベーション計画を企画中です。大分県にも協力を仰ぎ、移住や定住のための住まいとして活用してもらったり…。移住者が増えたら、クリエイターたちも増えていくし、大分県全体がもっと元気になるのではないかと思い、アイデアを膨らませている最中です。一大プロジェクトになりそうな予感です。


                  </div>
                </div>
              </div>
                <img src="../../img/kasugaura/image13.png" alt="" />
            </div>
          </div>
        </div>
        <div className="contentSection goodsSection" id="goods">

          <img src="../../img/kasugaura/image05.png" alt="story" className="contentSection_title" />
          <div className="tabs">
            <input id="tab01" type="radio" name="tab-item" />
            <label className="tab-item" htmlFor="tab01">
              <img src="../../img/kasugaura/image_tab01.png" alt="" />
            </label>
            <input id="tab02" type="radio" name="tab-item"/>
            <label className="tab-item" htmlFor="tab02">
              <img src="../../img/kasugaura/image_tab02.png" alt="" />
            </label>
            <input id="tab03" type="radio" name="tab-item"/>
            <label className="tab-item" htmlFor="tab03">
              <img src="../../img/kasugaura/image_tab03.png" alt="" />
            </label>
            <div className="tabContent" id="tab01-content">
              <div className="tabContent_description">
                <div className="bgColor01">

                  <div className="tabContent_title">
                  デザイン性と機能性を追求した愛されエプロン
                  </div>
                  <div className="boxRow">
                    <div className="boxRow_image">
                      <img src="../../img/kasugaura/image_tab01_01.png" alt="story" />
                    </div>
                    <div className="boxRow_item">
                      <p>
                      スマホを入れられる大きなポケットを配し、ファッションアイテムとしても使える機能性とデザイン性に優れたエプロン。丈夫で長く使うことができる帆布生地で、使い込むごとに味が出るアイテムです。お尻がすっぽり隠れるギャルソンエプロンは、体型をカバーできるのも嬉しいポイント。
                      </p>
                      {/* <div className="link">
                        <a href="https://tostv.thebase.in/items/66897351" target='_blank' className="link_button">
                          商品販売サイトへ
                          <img src="../../img/kasugaura/icon_arrowRight01.png" alt="" />
                        </a>
                      </div> */}
                    </div>
                  </div>
                  <div className="boxRow">
                    <div className="boxRow_image02">

                      <img src="../../img/kasugaura/image_tab01_02.png" alt="story" />
                    </div>
                    <div className="boxRow_image02">

                      <img src="../../img/kasugaura/image_tab01_03.png" alt="story" />
                    </div>
                    <div className="boxRow_image02">

                      <img src="../../img/kasugaura/image_tab01_04.png" alt="story" />
                    </div>
                  </div>
                  <div className="collabo">
                    <img src="../../img/kasugaura/image06.png" alt="collabo_title" className="collabo_title" />
                    <div className="boxRow">
                      <div className="boxRow_item">
                        <div className="title">
                        佐藤防水店
                        </div>
                        <div className="text">
                        テントやトラックシートや幌、特殊カバーを製造する、1951年創業の老舗テント店。専門店ならではの技術とノウハウを活かし、質実剛健なオリジナルバッグ作りに励んでいます。
                        </div>
                        <div className="sns">
                          <a href="https://www.instagram.com/resew_oita/" target='_blank'>
                            <img src="../../img/kasugaura/icon_sns01.png" alt="instagram" className="sns_item" />
                          </a>
                        </div>
                      </div>
                      <div className="boxRow_item">
                        <div className="comment">
                          <div className="text">
                          アドバイスいただきながら厚すぎない帆布生地を取り入れることに。無駄を削ぎ落としたシンプルさ、マチのある着脱可能なポケットなど、見た目も機能性も◎なエプロンが出来上がりました。
                          </div>
                          <img src="../../img/kasugaura/image_comment01.png" alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="link">
                      <a href="https://sato-bosui.com/" target='_blank' className="link_button">
                        佐藤防水店ホームページへ
                        <img src="../../img/kasugaura/icon_arrowRight01.png" alt="" />
                      </a>
                    </div>
                  </div>
                </div>

                <div className="album">
                  <img src="../../img/kasugaura/image10.png" alt="album_title" className="album_title" />
                  <div className="albumList">
                    <div className="albumList_item">
                      <div className="albumList_image">

                        <img src="../../img/kasugaura/image_tab01_05.png" alt="album" />
                      </div>
                      <div className="albumList_contents">
                        <div className="num">
                          #01
                        </div>
                        <div className="text">
                        DIYクリエイターらと生地選びとデザインを考え、サンプルを制作。ポケットの大きさや形状など、さらにブラッシュアップしていきます。
                        </div>
                      </div>

                    </div>
                    <div className="albumList_item">
                      <div className="albumList_image">

                        <img src="../../img/kasugaura/image_tab01_06.png" alt="album" />
                      </div>
                      <div className="albumList_contents">
                        <div className="num">
                          #02
                        </div>
                        <div className="text">
                        約1ヶ月を経て商品が完成しました！記念に女子4人でコラボ先の「佐藤防水店」前で記念撮影♪総監督とDが流行り病で不在ww
                        </div>
                      </div>

                    </div>
                    <div className="albumList_item">
                      <div className="albumList_image">

                        <img src="../../img/kasugaura/image_tab01_07.png" alt="album" />
                      </div>
                      <div className="albumList_contents">
                        <div className="num">
                          #03
                        </div>
                        <div className="text">
                        実際に着用して、カメラに向かってエプロンのこだわりや魅力をPR中！
                        </div>
                      </div>

                    </div>
                    <div className="albumList_item">
                      <div className="albumList_image">

                        <img src="../../img/kasugaura/image_tab01_08.png" alt="album" />
                      </div>
                      <div className="albumList_contents">
                        <div className="num">
                          #04
                        </div>
                        <div className="text">
                        DIYの相棒になりそうなおしゃれなエプロンにみんな大満足♪
                        </div>
                      </div>

                    </div>
                  </div>
                    <div className="link">
                      <a href="https://www.youtube.com/playlist?list=PL8Z5LUq5vV-0dSdP9hs8TJbmZBfBlNK2j" target='_blank' className="link_button">
                      番組アーカイブYOUTUBEはコチラ
                        <img src="../../img/kasugaura/icon_arrowRight02.png" alt="" />
                      </a>
                    </div>
                </div>

              </div>
            </div>
            <div className="tabContent" id="tab02-content">
              <div className="tab_content_description">
                <div className="bgColor02">

                  <div className="tabContent_title">
                  DIYでアレンジ可能！使い勝手抜群の卓上シェルフ
                  </div>
                  <div className="boxRow">
                    <div className="boxRow_image">
                      <img src="../../img/kasugaura/image_tab02_01.png" alt="story" />
                    </div>
                    <div className="boxRow_item">
                      <p>
                      足場板とブラックのアイアン脚を使った卓上シェルフです。調味料や小物を置くシェルフとしてだけでなく、天井から吊り下げたり、ブックエンドとして活用したり、使い方は自由自在。自分で一から組み立てるDIYキットなので、使い方に合わせてアレンジできる商品です。
                      </p>
                      {/* <div className="link">
                        <a href="https://tostv.thebase.in/items/66897589" target='_blank' className="link_button">
                          商品販売サイトへ
                          <img src="../../img/kasugaura/icon_arrowRight01.png" alt="" />
                        </a>
                      </div> */}
                    </div>
                  </div>
                  <div className="boxRow">
                    <div className="boxRow_image02">

                      <img src="../../img/kasugaura/image_tab02_02.png" alt="story" />
                    </div>
                    <div className="boxRow_image02">

                      <img src="../../img/kasugaura/image_tab02_03.png" alt="story" />
                    </div>
                    <div className="boxRow_image02">

                      <img src="../../img/kasugaura/image_tab02_04.png" alt="story" />
                    </div>
                  </div>
                  <div className="collabo">
                    <img src="../../img/kasugaura/image06.png" alt="collabo_title" className="collabo_title" />
                    <div className="boxRow">
                      <div className="boxRow_item">
                        <div className="title">
                        COBA INDUSTRIAL WORKS
                        </div>
                        <div className="text">
                        古材をアップサイクルし、味わいとぬくもりのある使い古した足場板、それぞれ表情の違う黒皮鉄に、金属加工技術を融合したアイアンパーツを使い、新しくも懐かしい家具や雑貨、DIY用のパーツを製作しているメーカーです。
                        </div>
                        <div className="sns">
                          <a href="https://www.instagram.com/coba_industrial_works/" target='_blank'>
                            <img src="../../img/kasugaura/icon_sns01.png" alt="instagram" className="sns_item" />
                          </a>
                        </div>
                      </div>
                      <div className="boxRow_item">
                        <div className="comment">
                          <div className="text">
                          店内には、職人の技術が光るアイアンパーツや現場で使われてきた足場板がズラリ。オリジナルパーツのおかげで、玄関からダイニング、キッチンまで、さまざまな場所で使えそうです。
                          </div>
                          <img src="../../img/kasugaura/image_tab02_05.png" alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="link">
                      <a href="https://www.cobaindustrialworks.com/" target='_blank' className="link_button">
                      COBA INDUSTRIAL WORKS<br />
                      ホームページへ
                        <img src="../../img/kasugaura/icon_arrowRight01.png" alt="" />
                      </a>
                    </div>
                  </div>
                </div>

                <div className="album">
                  <img src="../../img/kasugaura/image10.png" alt="album_title" className="album_title" />
                  <div className="albumList">
                    <div className="albumList_item">
                      <div className="albumList_image">

                        <img src="../../img/kasugaura/image_tab02_06.png" alt="album" />
                      </div>
                      <div className="albumList_contents">
                        <div className="num">
                          #01
                        </div>
                        <div className="text">
                        岩崎朋美さん、Reksさんとベツダイ姫野の3人で福岡県にある「COBA INDUSTRIAL WORKS」へ！
                        </div>
                      </div>

                    </div>
                    <div className="albumList_item">
                      <div className="albumList_image">

                        <img src="../../img/kasugaura/image_tab02_07.png" alt="album" />
                      </div>
                      <div className="albumList_contents">
                        <div className="num">
                          #02
                        </div>
                        <div className="text">
                        実際にアイアンパーツを手に取りながらシェルフの活用方法を考えていきます。
                        </div>
                      </div>

                    </div>
                    <div className="albumList_item">
                      <div className="albumList_image">

                        <img src="../../img/kasugaura/image_tab02_08.png" alt="album" />
                      </div>
                      <div className="albumList_contents">
                        <div className="num">
                          #03
                        </div>
                        <div className="text">
                        使い勝手の良い卓上シェルフをベースに、初心者でも気軽につくりやすいDIYキットをつくることに！実際に工具で作っているところです♪
                        </div>
                      </div>

                    </div>
                    <div className="albumList_item">
                      <div className="albumList_image">

                        <img src="../../img/kasugaura/image_tab02_09.png" alt="album" />
                      </div>
                      <div className="albumList_contents">
                        <div className="num">
                          #04
                        </div>
                        <div className="text">
                        オリジナルパーツ「ハンギングJ」を活用することで、鍵やマグカップなどが吊り下げ可能！
                        </div>
                      </div>

                    </div>
                  </div>
                    <div className="link">
                      <a href="https://www.youtube.com/playlist?list=PL8Z5LUq5vV-0dSdP9hs8TJbmZBfBlNK2j" target='_blank' className="link_button">
                      番組アーカイブYOUTUBEはコチラ
                        <img src="../../img/kasugaura/icon_arrowRight02.png" alt="" />
                      </a>
                    </div>
                </div>
              </div>
            </div>
            <div className="tabContent" id="tab03-content">
              <div className="tab_content_description">
              <div className="bgColor03">

                <div className="tabContent_title">
                自分仕様にカスタマイズできる木製パレット
                </div>
                <div className="boxRow">
                  <div className="boxRow_image">
                    <img src="../../img/kasugaura/image_tab03_01.png" alt="story" />
                  </div>
                  <div className="boxRow_item">
                    <p>
                    リモートワーク用の小さなデスクとして、空間を仕切るパーテーションとして、自由に活用できる木製のパレット。平安伸銅工業の突っ張り棒や木材にはめ込むDIYパーツ「ラブリコ」と組み合わせれば収納アイテムにも生まれ変わり、フレキシブルさも魅力です。
                    </p>
                    {/* <div className="link">
                      <a href="https://tostv.thebase.in/items/66897748" target='_blank' className="link_button">
                        商品販売サイトへ
                        <img src="../../img/kasugaura/icon_arrowRight01.png" alt="" />
                      </a>
                    </div> */}
                  </div>
                </div>
                <div className="boxRow">
                  <div className="boxRow_image02">

                    <img src="../../img/kasugaura/image_tab03_02.png" alt="story" />
                  </div>
                  <div className="boxRow_image02">

                    <img src="../../img/kasugaura/image_tab03_03.png" alt="story" />
                  </div>
                  <div className="boxRow_image02">

                    <img src="../../img/kasugaura/image_tab03_04.png" alt="story" />
                  </div>
                </div>
                <div className="collabo">
                  <img src="../../img/kasugaura/image06.png" alt="collabo_title" className="collabo_title" />
                  <div className="boxRow">
                    <div className="boxRow_item">
                      <div className="title">
                      平安伸銅工業
                      </div>
                      <div className="text">
                      収納にかかわる生活雑貨を企画開発しているメーカー。研究と改良を重ねた主力製品「突っ張り棒」や、安全で手軽なDIYブランド「ラブリコ（LABRICO）」など、便利なアイテムが多数揃います。
                      </div>
                      <div className="sns">
                        <a href="https://www.instagram.com/labricoofficial/" target='_blank'>
                          <img src="../../img/kasugaura/icon_sns01.png" alt="instagram" className="sns_item" />
                        </a>
                      </div>
                    </div>
                    <div className="boxRow_item">
                      <div className="comment">
                        <div className="text">
                        企業が掲げる「暮らしを変えるをカンタンに」という想いに共感しました！気軽にDIYできる商品、質感やデザインにこだわったプロダクトなど、“自分らしい暮らし”が叶う商品ばかりです。
                        </div>
                        <img src="../../img/kasugaura/image_tab03_05.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="link">
                    <a href="https://www.heianshindo.co.jp/" target='_blank' className="link_button">
                    平安伸銅工業ホームページへ
                      <img src="../../img/kasugaura/icon_arrowRight01.png" alt="" />
                    </a>
                  </div>
                  <div className="boxRow">
                    <div className="boxRow_item">
                      <div className="title">
                      SATO COMPANY
                      </div>
                      <div className="text">
                      木製パレットの持つ新たな可能性を引き出すため、インテリアや家具、イベントブースの建築材として活用する、木製パレットの製造のパイオニア。使用済みパレットの無料回収や、オリジナル家具の製作も行います。
                      </div>
                      <div className="sns">
                        <a href="https://www.instagram.com/satocompany_marupa/" target='_blank'>
                          <img src="../../img/kasugaura/icon_sns01.png" alt="instagram" className="sns_item" />
                        </a>
                      </div>
                    </div>
                    <div className="boxRow_item">
                      <div className="comment">
                        <div className="text">
                        木製パレットは１cm単位でオーダでき、簡単に作れるDIYキットも販売しています。社内のギャラリーには、インテリア事例も展示され、木製パレットの新たな可能性を体感することができました！
                        </div>
                        <img src="../../img/kasugaura/image_tab03_06.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="link">
                    <a href="https://marupa.jp/" target='_bla
                    nk' className="link_button">
                      SATO COMPANYホームページへ
                      <img src="../../img/kasugaura/icon_arrowRight01.png" alt="" />
                    </a>
                  </div>
                </div>
              </div>

              <div className="album">
                <img src="../../img/kasugaura/image10.png" alt="album_title" className="album_title" />
                <div className="albumList">
                  <div className="albumList_item">
                    <div className="albumList_image">

                      <img src="../../img/kasugaura/image_tab03_07.png" alt="album" />
                    </div>
                    <div className="albumList_contents">
                      <div className="num">
                        #01
                      </div>
                      <div className="text">
                      ついに九州を飛び出し、東京にある「SATO COMPANY」へ。ワクワクが隠しきれない3人。
                      </div>
                    </div>

                  </div>
                  <div className="albumList_item">
                    <div className="albumList_image">

                      <img src="../../img/kasugaura/image_tab03_08.png" alt="album" />
                    </div>
                    <div className="albumList_contents">
                      <div className="num">
                        #02
                      </div>
                      <div className="text">
                      木製パレットを使ったギャラリー＆ラボには、デスクやパーテーションのサンプルがずらり！アイデアを膨らませていきます。
                      </div>
                    </div>

                  </div>
                  <div className="albumList_item">
                    <div className="albumList_image">

                      <img src="../../img/kasugaura/image_tab03_09.png" alt="album" />
                    </div>
                    <div className="albumList_contents">
                      <div className="num">
                        #03
                      </div>
                      <div className="text">
                      パレット２社目のコラボ先は、突っ張り棒やラブリコなど、DIYでも大活躍のアイテムを展開している大阪の「平安伸銅工業」へ。
                      </div>
                    </div>

                  </div>
                  <div className="albumList_item">
                    <div className="albumList_image">

                      <img src="../../img/kasugaura/image_tab03_10.png" alt="album" />
                    </div>
                    <div className="albumList_contents">
                      <div className="num">
                        #04
                      </div>
                      <div className="text">
                      「ラブリコ」を活用しながらパーテーションを制作することに。パレットの位置を変えればデスクへのアレンジも可能！
                      </div>
                    </div>

                  </div>
                </div>
                  <div className="link">
                    <a href="https://www.youtube.com/playlist?list=PL8Z5LUq5vV-0dSdP9hs8TJbmZBfBlNK2j" target='_blank' className="link_button">
                      番組アーカイブYOUTUBEはコチラ
                      <img src="../../img/kasugaura/icon_arrowRight02.png" alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className="contentSection memberSection" id="member">
          <img src="../../img/kasugaura/image08.png" alt="member" />
          <div className="member">
            <div className="member_item">
              <div className="member_image">
                <img src="../../img/kasugaura/image_member01.png" />
              </div>
              <div className="member_contents">
                <div className="title">
                岩崎朋美
                </div>
                <div className="text">
                リポーター歴24年、大分が誇るリポーター界のレジェンド。<br />
                大分県内でテレビ・ラジオなどを中心に活動中。主にイラストを得意とする。
                DIYコーナーが始まり4年目になるが、未だに覚束ないインパクト捌きには毎度ヒヤヒヤを隠せない。<br />
                会う度に髪が短くなる傾向。春日浦DIYのマドンナ的存在。
                </div>
                <div className="sns">
                  <a target='_blank' href="https://www.instagram.com/tomo0955/">
                    <img src="../../img/kasugaura/icon_sns01.png" alt="instagram" className="sns_item" />
                  </a>
                </div>
              </div>
            </div>
            <div className="member_item">
              <div className="member_image">
                <img src="../../img/kasugaura/image_member02.png" />
              </div>
              <div className="member_contents">
                <div className="title">
                aco
                </div>
                <div className="text">
                ライフスタイルを彩るhandmadeコンテンツ"soeur and sui."のディレクター 。
                ニュアンスカラーを使った空間づくりや作品を得意とし、メディアにも掲載多数。
                最近では錫(スズ)を加工したジュエリーの制作に一念発起し、wabisabiをコンセプトに絶賛創作活動中。
                インスタの表の顔ではかっこつけているが、おふざけ大好きで笑いのツボ浅め。精神年齢は推定15歳
                とにかく楽しければオールOKな我が道を行くB型女子。
                </div>
                <div className="sns">
                  <a target='_blank' href="https://www.instagram.com/___.aco/">
                    <img src="../../img/kasugaura/icon_sns01.png" alt="instagram" className="sns_item" />
                  </a>
                </div>
              </div>
            </div>
            <div className="member_item">
              <div className="member_image">
                <img src="../../img/kasugaura/image_member03.png" />
              </div>
              <div className="member_contents">
                <div className="title">
                路地裏屋reks
                </div>
                <div className="text">
                あの伝説の雑貨屋「ハチャメチャクラブ」店長。
                当時からモノづくりやDIYを行っていたが、一軒家購入を機にさらに本格的に取り組み始める。
                店舗アドバイザーや空間コーディネートなども手掛けている他、
                山善アンバサダーをはじめとした企業との取り組みにて全国区で活動中！
                廃材や錆をインテリアに取り入れるなど、マニアック層にも愛されるクリエイター。
                言い間違い、覚え間違いは日常茶飯事のド天然であり、老眼のためビス穴は見えてない。
                </div>
                <div className="sns">
                  <a target='_blank' href="https://www.instagram.com/reks_alley/">
                    <img src="../../img/kasugaura/icon_sns01.png" alt="instagram" className="sns_item" />
                  </a>
                </div>
              </div>
            </div>
            <div className="member_item">
              <div className="member_image">
                <img src="../../img/kasugaura/image_member04.png" />
              </div>
              <div className="member_contents">
                <div className="title">
                HACHICO.
                </div>
                <div className="text">
                飽き性の模様替え好きからDIYの沼にハマる。
                シンプルでナチュラルなインテリアを得意とし、インテリア・DIY雑誌に多数掲載。
                DIYの強みを生かした手作りパーツのアクセサリーは芸能人への衣装提供されるほどの人気。
                Zoomでの1mmも動かない静止画ネタはもはや鉄板。
                クリエイター活動と並行してオタ活までこなす顔出し&日光NGの日陰系DIYer。
                </div>
                <div className="sns">
                  <a target='_blank' href="https://www.instagram.com/hachico.co/">
                    <img src="../../img/kasugaura/icon_sns01.png" alt="instagram" className="sns_item" />
                  </a>
                </div>
              </div>
            </div>
            <div className="member_item">
              <div className="member_image">
                <img src="../../img/kasugaura/image_member05.png" />
              </div>
              <div className="member_contents">
                <div className="title">
                姫野友輔
                </div>
                <div className="text">
                春日浦DIYの仕掛け人であり、普段は幅広い業務のなかで、なぜか毎週ラジオDJもこなす。
                仕掛け人でありながらその笑い声は外まで響き渡るため、どこにいようが場所はバレる。
                ふいに仕事を始めたり忙しくなると、おふざけに取り合わなくなるるツンデレっぷりを発揮。
                いざという時に一番頼りになるのか、いざという時しか動かないのか？春日浦DIYの総監督兼ガヤ。
                </div>
                <div className="sns">
                  <a target='_blank' href="https://www.instagram.com/joejoe6115/">
                    <img src="../../img/kasugaura/icon_sns01.png" alt="instagram" className="sns_item" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
  <div/>
</div>
  )
}

export default kasugauraPage
